import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { usePackageAnalytics } from "@/hooks/usePackageAnalytics";
import { TrendingUp, Package, DollarSign, Eye } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export const PackagePerformanceWidget = () => {
  const { data: analytics, isLoading } = usePackageAnalytics();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-64" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-32 w-full" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Package className="w-5 h-5 text-blue-600" />
          أداء الباقات السياحية
        </CardTitle>
        <CardDescription>ملخص شامل للباقات والحجوزات</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-sm text-muted-foreground">إجمالي الباقات</div>
            <div className="text-2xl font-bold text-blue-600">{analytics?.totalPackages || 0}</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-sm text-muted-foreground">الباقات النشطة</div>
            <div className="text-2xl font-bold text-green-600">{analytics?.activePackages || 0}</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-sm text-muted-foreground flex items-center gap-1">
              <Eye className="w-4 h-4" />
              المشاهدات
            </div>
            <div className="text-2xl font-bold text-purple-600">{analytics?.totalPackageViews || 0}</div>
          </div>
          <div className="bg-white rounded-lg p-4 shadow-sm">
            <div className="text-sm text-muted-foreground flex items-center gap-1">
              <DollarSign className="w-4 h-4" />
              الإيرادات
            </div>
            <div className="text-2xl font-bold text-amber-600">
              {analytics?.totalRevenue.toLocaleString() || 0} ريال
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-semibold flex items-center gap-2">
              <TrendingUp className="w-4 h-4" />
              أفضل 5 باقات
            </h4>
          </div>
          {analytics?.topPerformingPackages.map((pkg, index) => (
            <div key={pkg.id} className="bg-white rounded-lg p-3 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold ${
                    index === 0 ? 'bg-yellow-100 text-yellow-700' :
                    index === 1 ? 'bg-gray-100 text-gray-700' :
                    index === 2 ? 'bg-orange-100 text-orange-700' :
                    'bg-blue-100 text-blue-700'
                  }`}>
                    {index + 1}
                  </div>
                  <div>
                    <div className="font-medium text-sm">{pkg.title}</div>
                    <div className="text-xs text-muted-foreground">
                      {pkg.bookings} حجز • معدل تحويل {pkg.conversionRate}%
                    </div>
                  </div>
                </div>
                <div className="text-left">
                  <div className="font-semibold text-green-600">{pkg.revenue.toLocaleString()} ريال</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
